// Home-page swarm point: position + per-drone color come from CPU-updated
// buffers (the launch choreography writes both every frame). A small idle
// drift keeps a settled swarm alive; twinkle gives the LED shimmer.
attribute vec3 aColor;
attribute float aSeed;

uniform float uTime;
uniform float uSize;

varying vec3 vColor;
varying float vTwinkle;

void main() {
  vec3 pos = position;
  float d = 0.02;
  pos.x += sin(uTime * 0.6 + aSeed * 30.0) * d;
  pos.y += cos(uTime * 0.5 + aSeed * 22.0) * d;
  pos.z += sin(uTime * 0.7 + aSeed * 17.0) * d;

  vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
  gl_Position = projectionMatrix * mvPosition;

  // perspective-correct point size, sized in px at ~8 units out
  gl_PointSize = clamp(uSize * (8.0 / max(-mvPosition.z, 0.001)), 1.0, 48.0);

  vTwinkle = 0.85 + 0.15 * sin(uTime * 3.0 + aSeed * 120.0);
  vColor = aColor;
}
